import React from 'react';
import styled from 'styled-components';

import {Tooltip} from './../Tooltip';
const TruncationWrapper = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

/**
 * This is a hack fix for: https://wandb.atlassian.net/browse/WB-12440
 * It's not implementing the desired solution, and _we shouldn't build on this_
 * as it's passing options through a wandb component that's passing through a
 * to be deprecated semantic-ui-react component.
 *
 * I'm only doing this because the current UI state is pretty gross, and I want
 * to get up an improvment in the short-term
 */
export const TruncatedText = ({children}: {children: React.ReactNode}) => {
  return (
    <Tooltip
      content={children}
      position="top center"
      trigger={<TruncationWrapper>{children}</TruncationWrapper>}></Tooltip>
  );
};
